<template>
	<div class="home_wrapper">
		<div class="home_container" v-lazy:background-image="bgImg">
			<HelloWorldPc msg="This is views-pc-HomeView" />

			<ContactUsPc v-if="isHideForTest" />
		</div>

		<ApplySencePc v-if="isHideForTest" />

		<ProductsServicesPc />

		<GlobalGamePc v-if="isHideForTest" />

		<GlobalDeploymentPc v-if="isHideForTest" />

		<BusinessCooperationPc />
		
		<FooterMenuPc />
	</div>
</template>

<script>
/**
 * Pc HomeView
 * @ is an alias to /src
 */
import { mapState }           from 'vuex';
import { goToHome }           from '@/utils/routerUtils';
import { NAV_IS_PAGE_SCROLL } from '@/type/mutation';
import HelloWorldPc           from '@/components/pc/HelloWorld.vue';
import ApplySencePc           from '@/components/pc/ApplySence.vue';
import ProductsServicesPc     from '@/components/pc/ProductsServices.vue';
import GlobalGamePc           from '@/components/pc/GlobalGame.vue';
import GlobalDeploymentPc     from '@/components/pc/GlobalDeployment.vue';
import BusinessCooperationPc  from '@/components/pc/BusinessCooperation.vue';
import ContactUsPc            from '@/components/pc/ContactUs.vue';
import FooterMenuPc           from '@/components/pc/FooterMenu.vue';
import homeContainerBgImg     from '@/assets/static/imgs/home/index-bg-b0.png';// 父级容器背景图

export default {
	name      : 'HomeViewPc',
	components: {
		HelloWorldPc,
		ApplySencePc,
		ProductsServicesPc,
		GlobalGamePc,
		GlobalDeploymentPc,
		BusinessCooperationPc,
		ContactUsPc,
		FooterMenuPc
	},
	data() {
		return {

		};
	},

	mounted() {
		// 将页面滚动到左上角 (x:0, y:0)，重置页面位置
		window.scrollTo(0, 0);

		// 动态添加背景图、设置相关属性
		this.addBackgroundImage();

		// 监听页面滚动
    	window.addEventListener('scroll', this.handleScroll);
	},

	methods: {
		// 动态添加背景图
		addBackgroundImage()
		{
			const container                    = document.querySelector('.home_container');
			// container.style.background      = `rgba(162, 112, 234, .2) url(${this.bgImg}) center top no-repeat`;
			// container.style.background      = `url(${this.bgImg})`;
			container.style.backgroundPosition = `center top`;
			container.style.backgroundRepeat   = `no-repeat`;
			container.style.backgroundSize     = `cover`;
		},

		// 监听页面滚动
		handleScroll()
		{
			let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
	        if(scrollTop)// 如果滚动距离大于0，则显示导航栏背景色
			{
				this.$store.commit(NAV_IS_PAGE_SCROLL, true);
	      	}
			else if(scrollTop === 0)// 如果滚动距离等于0，则显示导航栏背景色
			{
				this.$store.commit(NAV_IS_PAGE_SCROLL, false);
	      	}
		},

		// 跳转至首页
		goHome()
		{
			goToHome(this.$router);
		},

		// 跳转至全部游戏页
		gotoAllGames()
		{
			this.$router.push('/allgames');
		}
	},

	computed: {
		// ES6展开合并运算符
		...mapState([
			'isHideForTest'
		]),

		// 父级容器背景图
		bgImg() {
			return homeContainerBgImg;
		}
	},

	beforeDestroy() {
		window.removeEventListener("scroll", this.handleScroll);
	}
}
</script>

<style lang="less" scoped>
.home_wrapper{
	width:100%;height:auto;
	padding-top:0;
}
.home_container{
	display:flex;justify-content:center;align-items:flex-start;
	width:100%;height:var(--com-base-top-container-h2);
}
</style>
